<template>
    <spinner v-if="isLoading"></spinner>
    
    <v-infinite-scroll v-else-if="! isLoading" id="messageContainer" @top="prevPage" style="overflow-y: scroll;">  
    <div id="prevmessagelabel" v-if="! blockTopPagination">
      Scrolla verso l'alto per leggere i messaggi precedenti
      <font-awesome-icon  v-if="isLoadingPreviousMessages" icon="spinner" class="fa-spin spinnermessage" /></div>      
    <div id="searchStringbar" v-if="countOccur>0">
      <font-awesome-icon @click="prevOccur" icon="arrow-up" class="cicon" />
      <font-awesome-icon @click="nextOccur" icon="arrow-down" class="cicon" />
      {{currentOccur}} di {{countOccur}} risultati per "{{searchString}}"

      <font-awesome-icon @click="closeSearch" icon="times" class="cicon close" />
    </div>

    <div v-if="countOccur>0" class="moretoppadding"></div>

    <div v-if="this.messages.length == 0">
        Nessun messaggio trovato
    </div>    
		<div v-for="message in messages" :key="message.id" :id="message.id" class="messages clearfix" >         
		  <simple
			v-if="message.type == 'simpleText'"
			:direction="message.direction"
			:type="message.type"
			:content="message.content.text"      
		  ></simple>
		  <list v-if="message.type == 'listitems'" :content="message.content"></list>
		  <card v-if="message.type === 'simplecard'" :content="message.content" :type="message.type"></card>
		  <flickity
			v-if="message.type == 'simpleCarousel'"
			ref="flickity"
			:options="flickityCarouselOptions"
			class="carouselcards"
		  >
			<card
			  v-for="card in message.content.items"
			  :key="card.id"
			  :content="card"
			  :type="card.type"
			></card>
		  </flickity>
		  <flickity
			v-if="message.type == 'browserCarousel'"
			ref="flickity"
			:options="flickityBrowseOptions"
			class="browsecards"
		  >
			<card
			  v-for="card in message.content.items"
			  :key="card.id"
			  :content="card"
			  :type="card.type"
			></card>
		  </flickity>
		  <div hidden v-if="message.type == 'suggestions'">
			<simple :title="message.title" :content="message.content.suggestions" :type="message.type"></simple>
		  </div>
		  <div v-if="message.type == 'mediacard'">
			<card :content="message.content" :type="message.type"></card>
		  </div>
		  <simple
			v-if="message.type == 'linkout'"
			:type="message.type"
			:title="message.title"
			:content="message.content"
		  ></simple>
		  <simple
			v-if="message.type == 'tablecard'"
			:type="message.type"
			:title="message.gridtext"
			:columns="message.gridColumn"
			:content="message.content"
		  ></simple>
		  <simple v-if="message.type == 'upload'" :content="message.title" :type="message.type"></simple>
		  <simple v-if="message.type == 'register'" :content="message.content" :type="message.type"></simple>
		  <simple v-if="message.type == 'html'" :content="message.content.html" :type="message.type"></simple>      
		</div>             
		<simple v-if="typing == true" :type="'typing'"></simple>	  
    </v-infinite-scroll>  	  
</template>
<script>
import Vue from 'vue'
 
import InfiniteScroll from 'v-infinite-scroll'
 
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-infinite-scroll/dist/v-infinite-scroll.css'
 
Vue.use(InfiniteScroll)


import ChatMessageRepository from './../repositories/ChatMessageRepository';
import spinner from './CustomLoader'

import Flickity from "vue-flickity";

/** Message Types **/
import Simple from "./messagetypes/Simple.vue";
import List from "./messagetypes/List.vue";
import Card from "./messagetypes/Card.vue";
import Intro from "./messagetypes/Intro.vue";

 
var options = {
    container: '#messageContainer',
    easing: 'linear',
    offset: 60,
    force: true,
    cancelable: true,
    x: false,
    y: true
}

export default {
  mixins: [ChatMessageRepository], 
  name: "messageContainer",
  components: {
    Simple,
    List,
    Card,
    Intro,
    Flickity,    
    spinner
  },
  data() {
    return {
      typing: false,
      searchString: '',
      countOccur:0,
      currentOccur:1,
      prevmessageexists:false,
      flickityCarouselOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: false,
        cellAlign: "left",
        freeScroll: false,
        groupCells: "90%",
        draggable: false,
        prevNextButtons: true,        
      },
      flickityBrowseOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: false,
        cellAlign: "left",
        freeScroll: false,
        groupCells: "100%",
        draggable: true
      },
      messages: [],
      currentConversationId:0,
      firstMessageId:0,
      lastMessageId:0,
      isLoading:true ,
      isLoadingPreviousMessages:false,
      blockTopPagination:true     
    };
  },
};
</script>
<style>
.spinnermessage{
  position: absolute;
    text-align: center;
    top: 45px;
    left: calc(50% - 10px);
    color: #cae863;
    z-index: 999;
    font-size: 30px;
}
#prevmessagelabel{
position: relative;
    text-align: center;
    padding: 5px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
    border-radius: 5px;
}


#searchStringbar{
  position: fixed;
  background: #ececec;
  width: calc(100% + 30px);
  margin-top: -58px;
  margin-left: -15px;
  padding: 5px;
  border-bottom: 1px solid #ccc;
  z-index: 9;
  display: block;
}

.highlightText {
      background: yellow;
}

.highlightText.highselected{
      background: orange;
}

#searchStringbar .cicon{
  margin: 0 5px;
  vertical-align: bottom;
}

#searchStringbar .cicon.close{
  float:right;
  margin-right: 5px;
  opacity: 1;
}

#messageContainer {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 15px;
  height: calc(100vh - 130px);
  background: #fff;  
  border-left: 1px solid #ccc;
}

.moretoppadding{
  margin-top:40px; 
}
.message {
  padding: 5px 14px;
  border-radius: 25px;
  min-width: 2vw;
  max-width: 50%;
  position: relative;
  margin-bottom: 14px;
  clear: both;
}
.listitems .list-item {
  margin: 0px -14px;
  padding: 14px;
}

</style>